import { useRouter } from 'next/router';

import usePagination from '@mui/material/usePagination';

import PropTypes from 'prop-types';

const PAGINATION_SHOW_COUNT = 3;

export default function UsePagination(props) {
    const { count } = props;
    const pageNumber = parseInt(props.page, 10);
    const router = useRouter();
    const { query } = router;    
    const { items } = usePagination({
        count,
        page: pageNumber,
    });

    const changeToPageNumber = (pageTo) => {
        let newQuery;
        if (pageTo > 1) {
            newQuery = { ...query, page: pageTo };
        } else {
            newQuery = { ...query };
            delete newQuery.page;
        }
        return () => {
            router.push(
                {
                    pathname: '/bookings',
                    query: newQuery,
                },
                undefined,
                { shallow: true },
            );
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        };
    };

    const arrowNavigation = (type) => {
        if (type === 'previous' && pageNumber > 1) {
            return changeToPageNumber(pageNumber - 1);
        }
        if (type === 'next' && pageNumber < count) {
            return changeToPageNumber(pageNumber + 1);
        }
        return undefined;
    };

    return (
        <nav id="pagination-nav">
            <ul className='room-types-pager-pagination-ul'>

                {items.map(({ page, type, selected, disabled, ...item }, index) => {
                    
                    let children;
                    
                    if (type === 'start-ellipsis' || type === 'end-ellipsis') {

                        children = '…';

                    } else if (type === 'previous' || type === 'next') {                        
                        
                        let buttonClassName = 'room-types-pager-pagination-button';

                        if (type === 'next') {
                            if (count > 1) { 
                                buttonClassName += ' room-types-pager-pagination-button-active';
                            }else {
                                buttonClassName += ' room-types-pager-pagination-button-not-active';
                            }                            
                        } else if (type === 'previous') {
                            if (pageNumber === 1) {
                                buttonClassName += ' room-types-pager-pagination-button-not-active';
                            } else {
                                buttonClassName += ' room-types-pager-pagination-button-active';
                            }
                        }                        

                        children = (
                            <button
                                className={buttonClassName}
                                type="button"
                                {...item}
                                onClick={arrowNavigation(type)}                                
                            >
                                {type === 'previous' ? 'Prev' : 'Next'}
                            </button>
                        );
                    }

                    if (pageNumber <= PAGINATION_SHOW_COUNT) {
                        if (type === 'page' && index <= PAGINATION_SHOW_COUNT) {
                            children = (
                                <button
                                    className={`room-types-pager-pagination-page-button ${ selected ? 'room-types-pager-pagination-page-button-selected' : 'room-types-pager-pagination-page-button-not-selected'}`}
                                    type="button"                                    
                                    {...item}
                                    onClick={changeToPageNumber(page)}
                                >
                                    {page}
                                </button>
                            );
                        } else if (type === 'page' && index > PAGINATION_SHOW_COUNT) {
                            return null;
                        }
                    } else if (index > pageNumber - PAGINATION_SHOW_COUNT && index <= pageNumber) {
                        if (type === 'page') {
                            children = (
                                <button
                                    className={`room-types-pager-pagination-page-button ${ selected ? 'room-types-pager-pagination-page-button-selected' : 'room-types-pager-pagination-page-button-not-selected'}`}
                                    type="button"                                    
                                    {...item}
                                    onClick={changeToPageNumber(page)}
                                >
                                    {page}
                                </button>
                            );
                        } else if (type === 'page' && index > PAGINATION_SHOW_COUNT) {
                            return null;
                        }
                    }

                    return (
                        <li id={`pagination-nav-item-${index}`} key={index}>
                            {children}
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}

UsePagination.propTypes = {
    count: PropTypes.number,
    page: PropTypes.number,
};
